import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Lock, Wrench } from 'lucide-react';
import { directionForLanguage } from '../../i18n/config';
import './SkillPicker.css';

/** Placeholder for user-defined custom skills (dashboard-managed, coming soon). */
export const CustomSkillsPanel: React.FC = () => {
  const { t, i18n } = useTranslation('taskpane');
  const chromeDir = directionForLanguage(i18n.language);

  return (
    <div className="skill-picker" dir={chromeDir}>
      <p className="skill-picker-intro">{t('agent.skillsIntro')}</p>
      <div className="skill-picker-custom skill-picker-custom--standalone">
        <div className="skill-picker-custom-header">
          <Wrench size={14} aria-hidden />
          <span dir="ltr">Skills</span>
        </div>
        <p className="skill-picker-custom-desc">{t('agent.skillsComingSoon')}</p>
        <div className="skill-picker-custom-lock-row">
          <Lock size={16} aria-hidden />
          <span>{t('solutions.comingSoon')}</span>
        </div>
        <button type="button" className="skill-picker-custom-btn" disabled>
          {t('agent.createSkill')}
        </button>
      </div>
    </div>
  );
};
